import apiService from "@/core/services/apiService";

export type State = { classes: object };
import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/store.enums";
import { NavigationActions, NavigationMutation } from "@/modules/navigation/store/enums";
import store from "@/store";

@Module
export default class Store extends VuexModule {
  renderKey = 1;
  listParams = {
    page: 1,
    results: 10,
    search: null,
    sort: [],
    filter: {}
  };
  listCache = [];
  listTotal = 0;

  listGroupsParams = {
    page: 1,
    results: 10,
    search: null,
    sort: [],
    filter: {}
  };
  listGroupsCache = [];
  listGroupsTotal = 0;
  listGroupsFilterOptions = {};

  get getNavigationRenderKey() {
    return "navigation-" + this.renderKey;
  }

  get getNavigationLastListResult() {
    return this.listCache;
  }

  get getNavigationLastListTotal() {
    return this.listTotal;
  }

  get getNavigationGroupsLastListResult() {
    return this.listGroupsCache;
  }

  get getNavigationGroupsLastFilterOptions() {
    return this.listGroupsFilterOptions;
  }

  get getNavigationGroupsLastListTotal() {
    return this.listGroupsTotal;
  }

  @Mutation
  [NavigationMutation.SET_RENDER_UPDATE]() {
    this.renderKey++;
  }

  @Mutation
  [NavigationMutation.SET_LIST_RESULT]({ listParams, listTotal, listCache }) {
    this.listParams = listParams;
    this.listCache = listCache;
    this.listTotal = listTotal;
  }

  @Mutation
  [NavigationMutation.SET_GROUPS_LIST_RESULT]({
                                                listGroupsParams,
                                                listGroupsTotal,
                                                listGroupsCache,
                                                listGroupsFilterOptions
                                              }) {
    this.listGroupsParams = listGroupsParams;
    this.listGroupsCache = listGroupsCache;
    this.listGroupsTotal = listGroupsTotal;
    this.listGroupsFilterOptions = listGroupsFilterOptions;
  }

  @Action
  [NavigationActions.REFRESH_LIST]() {
    this.context.dispatch(NavigationActions.FETCH_LIST, this.listParams);
  }

  @Action
  [NavigationActions.REFRESH_GROUPS]() {
    this.context.dispatch(NavigationActions.FETCH_GROUPS, this.listParams);
  }

  @Action
  [NavigationActions.FETCH_LIST](params) {

    return new Promise<void>((resolve, reject) => {

      apiService.post("navigation/list", params).then((response) => {

        const data = response.data || null;

        const _verified = apiService.verifyApiResult(data);
        if (!_verified) {
          this.context.commit(Mutations.SET_ERROR, data);
          return reject();
        }

        // return results into storage for reactive update if needed //
        this.context.commit(NavigationMutation.SET_LIST_RESULT, {
          listParams: params,
          listTotal: data.results,
          listCache: data.result
        });
        resolve();

      }).catch((response) => {

        this.context.commit(Mutations.SET_ERROR, response);
        reject();

      });

    });

  };

  @Action
  [NavigationActions.GET_ITEM](detailId) {

    return new Promise<void>((resolve, reject) => {

      apiService.get(`navigation/get/${detailId}`).then(({ data }) => {

        const _verified = apiService.verifyApiResult(data);
        if (!_verified) {
          this.context.commit(Mutations.SET_ERROR, data);
          return reject();
        }

        // return results to dispatcher without mutation //
        resolve(data.result);

      }).catch((response) => {

        this.context.commit(Mutations.SET_ERROR, response);
        reject();

      });

    });

  };

  @Action
  [NavigationActions.CREATE_ITEM](payload) {

    return new Promise((resolve, reject) => {

      const { data } = payload;

      apiService.post("navigation/create/", data).then(({ data }) => {

        const _verified = apiService.verifyApiResult(data);
        if (!_verified) {
          this.context.commit(Mutations.SET_ERROR, data);
          return reject();
        }

        // flag cached keep alive comp to render new //
        this.context.commit(NavigationMutation.SET_RENDER_UPDATE);

        // refresh list in background//
        this.context.dispatch(NavigationActions.REFRESH_LIST);

        // return results to dispatcher without mutation //
        resolve(data.result);

      }).catch((response) => {

        this.context.commit(Mutations.SET_ERROR, response);
        reject();

      });

    });

  };

  @Action
  [NavigationActions.UPDATE_ITEM](payload) {

    return new Promise((resolve, reject) => {

      const { editId, data } = payload;

      apiService.put(`navigation/update/${editId}`, data).then(({ data }) => {

        const _verified = apiService.verifyApiResult(data);
        if (!_verified) {
          this.context.commit(Mutations.SET_ERROR, data);
          return reject();
        }

        // refresh list in background//
        this.context.dispatch(NavigationActions.REFRESH_LIST);

        // return results to dispatcher without mutation //
        resolve(data.result);

      }).catch((response) => {

        this.context.commit(Mutations.SET_ERROR, response);
        reject();

      });

    });

  };

    @Action
  [NavigationActions.UPDATE_ITEM_TRANSLATIONS](payload) {

    return new Promise((resolve, reject) => {

      const { editId, data } = payload;

      apiService.put(`navigation/update-translations/${editId}`, data).then(({ data }) => {

        const _verified = apiService.verifyApiResult(data);
        if (!_verified) {
          this.context.commit(Mutations.SET_ERROR, data);
          return reject();
        }

        // return results to dispatcher without mutation //
        resolve(data.result);

      }).catch((response) => {

        this.context.commit(Mutations.SET_ERROR, response);
        reject();

      });

    });

  };

  @Action
  [NavigationActions.DELETE_ITEM](editId) {

    return new Promise((resolve, reject) => {

      apiService.delete(`navigation/delete/${editId}`).then(({ data }) => {

        const _verified = apiService.verifyApiResult(data);
        if (!_verified) {
          this.context.commit(Mutations.SET_ERROR, data);
          return reject();
        }

        // refresh list in background//
        this.context.dispatch(NavigationActions.REFRESH_LIST);

        // return results to dispatcher without mutation //
        resolve(data.result);

      }).catch((response) => {

        this.context.commit(Mutations.SET_ERROR, response);
        reject();

      });

    });

  };


  @Action
  [NavigationActions.FETCH_GROUPS](params) {

    return new Promise<void>((resolve, reject) => {

      apiService.post("navigation/list-groups", params).then((response) => {

        const data = response.data || null;

        const _verified = apiService.verifyApiResult(data);
        if (!_verified) {
          this.context.commit(Mutations.SET_ERROR, data);
          return reject();
        }

        // return results into storage for reactive update if needed //
        this.context.commit(NavigationMutation.SET_GROUPS_LIST_RESULT, {
          listGroupsParams: params,
          listGroupsTotal: data.results,
          listGroupsCache: data.result,
          listGroupsFilterOptions: data.filter ?? {}
        });

        resolve();

      }).catch((response) => {

        this.context.commit(Mutations.SET_ERROR, response);
        reject();

      });

    });

  };

  @Action
  [NavigationActions.GET_GROUP](detailId) {

    return new Promise<void>((resolve, reject) => {

      apiService.get(`navigation/get-group/${detailId}`).then(({ data }) => {

        const _verified = apiService.verifyApiResult(data);
        if (!_verified) {
          this.context.commit(Mutations.SET_ERROR, data);
          return reject();
        }

        // return results to dispatcher without mutation //
        resolve(data.result);

      }).catch((response) => {

        this.context.commit(Mutations.SET_ERROR, response);
        reject();

      });

    });

  };

  @Action
  [NavigationActions.CREATE_GROUP](payload) {

    return new Promise((resolve, reject) => {

      const { data } = payload;

      apiService.post("navigation/create-group/", data).then(({ data }) => {

        const _verified = apiService.verifyApiResult(data);
        if (!_verified) {
          this.context.commit(Mutations.SET_ERROR, data);
          return reject();
        }

        // flag cached keep alive comp to render new //
        this.context.commit(NavigationMutation.SET_RENDER_UPDATE);

        // refresh list in background//
        this.context.dispatch(NavigationActions.REFRESH_GROUPS);

        // return results to dispatcher without mutation //
        resolve(data.result);

      }).catch((response) => {

        this.context.commit(Mutations.SET_ERROR, response);
        reject();

      });

    });

  };

  @Action
  [NavigationActions.UPDATE_GROUP](payload) {

    return new Promise((resolve, reject) => {

      const { editId, data } = payload;

      apiService.put(`navigation/update-group/${editId}`, data).then(({ data }) => {

        const _verified = apiService.verifyApiResult(data);
        if (!_verified) {
          this.context.commit(Mutations.SET_ERROR, data);
          return reject();
        }

        // refresh list in background//
        this.context.dispatch(NavigationActions.REFRESH_GROUPS);

        // return results to dispatcher without mutation //
        resolve(data.result);

      }).catch((response) => {

        this.context.commit(Mutations.SET_ERROR, response);
        reject();

      });

    });

  };

  @Action
  [NavigationActions.UPDATE_GROUP_RELATIONS](payload) {

    return new Promise((resolve, reject) => {

      const { editId, data } = payload;

      apiService.put(`navigation/update-group-relations/${editId}`, data).then(({ data }) => {

        const _verified = apiService.verifyApiResult(data);
        if (!_verified) {
          this.context.commit(Mutations.SET_ERROR, data);
          return reject();
        }

        // return results to dispatcher without mutation //
        resolve(data.result);

      }).catch((response) => {

        this.context.commit(Mutations.SET_ERROR, response);
        reject();

      });

    });

  };

  @Action
  [NavigationActions.DELETE_GROUP](editId) {

    return new Promise((resolve, reject) => {

      apiService.delete(`navigation/delete-group/${editId}`).then(({ data }) => {

        const _verified = apiService.verifyApiResult(data);
        if (!_verified) {
          this.context.commit(Mutations.SET_ERROR, data);
          return reject();
        }

        // refresh list //
        this.context.dispatch(NavigationActions.REFRESH_GROUPS);

        // return results to dispatcher without mutation //
        resolve(data.result);

      }).catch((response) => {

        this.context.commit(Mutations.SET_ERROR, response);
        reject();

      });

    });

  };

}
